import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AgentTurnAction,
  InterviewDepth,
  ViewResponse,
  ViewResponseCriteria,
} from '@app/shared/models/agent-chat.models';
import { AiChatSelectValue } from '@app/shared/models/agent-chat.models';
import { TurnConfig } from '@app/shared/services/agents.service';
import { Pagination } from '@app/shared/models/pagination';
import { Candidate } from '@app/shared/models/candidate';

export const startAgentSession = createAction(
  '[Chatbot] Start Agent Session',
  props<{ payload: { prompt: string; jdText?: string; interviewDepth: InterviewDepth } }>(),
);
export const executeStartAgentSession = createAction(
  '[Chatbot] Execute Start Agent Session',
  props<{
    payload: { prompt: string; threadId: string; jdText?: string; interviewDepth: InterviewDepth };
  }>(),
);

export const startAgentSessionSuccess = createAction(
  '[Chatbot] Start Agent Session Success',
  props<{ payload: { response: ViewResponse } }>(),
);

export const startAgentSessionError = createAction(
  '[Chatbot] Start Agent Session Error',
  props<{ error: HttpErrorResponse }>(),
);

export const continueAgentSession = createAction(
  '[Chatbot] Continue Agent Session',
  props<{
    payload: {
      prompt?: string;
      threadId: string;
      resumeConfig?: TurnConfig;
      selection?: AiChatSelectValue;
      showSelectionSummary?: boolean;
      useMessageTurn?: boolean;
      action?: AgentTurnAction;
    };
  }>(),
);

export const continueAgentSessionSuccess = createAction(
  '[Chatbot] Continue Agent Session Success',
  props<{ payload: { response: ViewResponse; threadId: string } }>(),
);

export const continueAgentSessionError = createAction(
  '[Chatbot] Continue Agent Session Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadAgentSessionState = createAction(
  '[Chatbot] Load Agent Session State',
  props<{ payload: { threadId: string } }>(),
);

export const loadAgentSessionStateSuccess = createAction(
  '[Chatbot] Load Agent Session State Success',
  props<{ payload: { response: ViewResponse; threadId: string } }>(),
);

export const loadAgentSessionStateError = createAction(
  '[Chatbot] Load Agent Session State Error',
  props<{ error: HttpErrorResponse }>(),
);

export const sendAckSuccess = createAction(
  '[Chatbot] Send Ack Success',
  props<{ payload: { ack: string | null } }>(),
);

export const sendAckError = createAction(
  '[Chatbot] Send Ack Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadChatbotResults = createAction(
  '[Chatbot] Load Chatbot Results',
  props<{
    payload: {
      page: number;
      restart?: boolean;
    };
  }>(),
);

export const loadChatbotResultsSuccess = createAction(
  '[Chatbot] Load Chatbot Results Success',
  props<{
    payload: {
      candidatesPage: Pagination<Candidate>;
    };
  }>(),
);

export const loadChatbotResultsError = createAction(
  '[Chatbot] Load Chatbot Results Error',
  props<{ error: HttpErrorResponse }>(),
);

export const stageCriteriaEdit = createAction(
  '[Chatbot] Stage Criteria Edit',
  props<{ payload: { threadId: string; criteria: ViewResponseCriteria[] } }>(),
);

export const discardStagedChanges = createAction(
  '[Chatbot] Discard Staged Changes',
  props<{ payload: { threadId: string } }>(),
);

export const stagedChangesReconciled = createAction(
  '[Chatbot] Staged Changes Reconciled',
  props<{ payload: { response: ViewResponse } }>(),
);

export const stagedChangesError = createAction(
  '[Chatbot] Staged Changes Error',
  props<{ error: HttpErrorResponse }>(),
);

export const applyStagedChanges = createAction(
  '[Chatbot] Apply Staged Changes',
  props<{ payload: { threadId: string } }>(),
);

export const applyStagedChangesError = createAction(
  '[Chatbot] Apply Staged Changes Error',
  props<{ error: HttpErrorResponse }>(),
);

export const reviewAndSearchEmbedded = createAction(
  '[Chatbot] Review And Search Embedded',
  props<{ payload: { threadId: string } }>(),
);

export const agentTurnProgressReceived = createAction(
  '[Chatbot] Agent Turn Progress Received',
  props<{ payload: { log: string[]; holds: string[] } }>(),
);

export const agentReplyDelta = createAction(
  '[Chatbot] Agent Reply Delta',
  props<{ payload: { text: string } }>(),
);

export const agentReplyReset = createAction('[Chatbot] Agent Reply Reset');

export const agentReplyDone = createAction('[Chatbot] Agent Reply Done');

export const agentReplySplit = createAction(
  '[Chatbot] Agent Reply Split',
  props<{ payload: { leadIn: string; ask: string } }>(),
);

export const agentTurnProgressLine = createAction(
  '[Chatbot] Agent Turn Progress Line',
  props<{ payload: { text: string; holds: string[] } }>(),
);
